export default "__VITE_ASSET__Rrs3aNDl__"